/*
 * @Author: your name
 * @Date: 2019-12-15 15:21:25
 * @LastEditTime : 2020-01-21 18:32:36
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\router\modules\workerGroup.js
 */
const WorkerGroiup = () => import('@/views/workerGroup/index')//工匠集群
const WorkerGroupDetail = () => import('@/views/workerGroup/WorkerGroupDetail')//详情

const workerGroupRouter = [
    {
        name: 'workerGroup',
        path: '/workerGroup',
        component: WorkerGroiup,
        meta: {
            name: '工匠集群'
        }
    },
    {
        name: 'workerGroupDetail',
        path: '/workerGroupDetail/:typeName',
        component: WorkerGroupDetail,
        meta: {
            name: '工匠集群详情'
        }
    }
]
export default workerGroupRouter;


// WEBPACK FOOTER //
// ./src/router/modules/workerGroup.js